import React, { useEffect, useState } from 'react';
import { css, StyleSheet } from 'aphrodite';
import { Typography } from '@mui/material';

const RecentActivity = () => {
  const [activities, setActivities] = useState([]);

  // useEffect(() => {
  //   const fetchActivities = async () => {
  //     try {
  //       const response = await fetch("/hospital/recent-activity"); // Adjust endpoint as needed
  //       const data = await response.json();
  //       setActivities(data);
  //     } catch (error) {
  //       console.error("Error fetching recent activity:", error);
  //     }
  //   };

  //   fetchActivities();
  //   const interval = setInterval(fetchActivities, 5000); // Refresh every 5s
  //   return () => clearInterval(interval);
  // }, []);

  return (
    <div className={css(styles.container)}>
      <Typography variant='h4' className={css(styles.title)}>
        Recent activity
      </Typography>
      <ul className={css(styles.list)}>
        {activities.map((activity) => (
          <li key={activity.id} className={css(styles.activityItem)}>
            <div className={css(styles.actionRow)}>
              <span className={css(styles.action)}>{activity.action}</span>
              <span className={css(styles.chip, styles[activity.type])}>{activity.type}</span>
            </div>
            <div className={css(styles.details)}>
              <span className={css(styles.subject)}>{activity.subject}</span>
              <span className={css(styles.time)}>{activity.time}</span>
            </div>
          </li>
        ))}
      </ul>
    </div>
  );
};

const styles = StyleSheet.create({
  container: {
    padding: '16px',
    backgroundColor: '#fff',
    borderRadius: '8px'
    // boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
  },
  title: {
    color: '#1976d2',
    marginBottom: '1.5rem',
    fontWeight: 'bold',
    fontSize: '1.8rem',
    '@media (max-width: 600px)': {
      fontSize: '1.5rem'
    }
  },
  list: {
    listStyle: 'none',
    padding: 0
  },
  activityItem: {
    padding: '10px 0',
    borderBottom: '1px solid #e0e0e0'
  },
  actionRow: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center'
  },
  action: {
    fontWeight: 'bold'
  },
  chip: {
    padding: '2px 8px',
    borderRadius: '12px',
    fontSize: '12px'
  },
  admission: { backgroundColor: '#e8f5e9', color: '#2e7d32' },
  discharge: { backgroundColor: '#e3f2fd', color: '#1976d2' },
  appointment: { backgroundColor: '#f3e5f5', color: '#7b1fa2' },
  lab: { backgroundColor: '#fff3e0', color: '#e65100' },
  details: {
    fontSize: '14px',
    color: '#616161'
  },
  subject: {
    fontWeight: '500'
  },
  time: {
    fontSize: '12px',
    color: '#9e9e9e'
  }
});

export default RecentActivity;
